var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{staticClass:"pinch-modal"},[_c('button',{staticClass:"pinch-modal-close pz-zoom-button",on:{"click":function($event){return _vm.$emit('close')}}}),_vm._v(" "),_c('pinch-zoom',{attrs:{"disable-zoom-control":"never"}},[_c('img',{attrs:{"src":_vm.src}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }